
export function toggleDarkMode(isSwitchedOn) {
    if (isSwitchedOn) {
        document.documentElement.style.setProperty('--white-color', '#3b3a30');
        document.documentElement.style.setProperty('--dark-grey', '#ffffff');
        document.documentElement.style.setProperty('--black-color', '#ffffff');
        document.documentElement.style.setProperty('--mid-grey', '#d2d2d8');
        document.documentElement.style.setProperty('--light-grey', '#63636d');
    } else {
        document.documentElement.style.setProperty('--white-color', '#ffffff');
        document.documentElement.style.setProperty('--dark-grey', '#3b3a30');
        document.documentElement.style.setProperty('--black-color', 'black');
        document.documentElement.style.setProperty('--mid-grey', '#63636d');
        document.documentElement.style.setProperty('--light-grey', '#d2d2d8');

    }
}
